// extracted by mini-css-extract-plugin
export default {"search":"searchStock_search__6fr5y"};